// extracted by mini-css-extract-plugin
export default {"noLibraryTasksContainer":"LibraryTasksEmpty_noLibraryTasksContainer__D6aMT"};